'use client';

import { saveBirthDate } from 'actions/Database';
import { useState, useTransition } from 'react';
import { ComponentFields } from 'types/content';
import FormError from './FormError';
import { useAppSelector } from 'lib/hooks';
import { useDispatch } from 'react-redux';
import { selectBirthday, setUserDatabase } from 'slices/userSlice';
import { DBUser } from 'db/schema/users';

const BEQLookupForm = ({ data, onContinue }: ComponentFields) => {
  const dispatch = useDispatch();

  const existingBirthday = useAppSelector(selectBirthday);

  const [birthday, setBirthday] = useState<string>(existingBirthday ?? '');
  const [birthdayError, setBirthdayError] = useState<string>('');
  const [isPending, startTransition] = useTransition();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!birthday) {
      setBirthdayError('Birthday is required');
      return;
    }
    setBirthdayError('');
    startTransition(async () => {
      const user: DBUser = await saveBirthDate(birthday);
      dispatch(
        setUserDatabase({ ...user, created_at: null, updated_at: null })
      );
      onContinue();
    });
  };

  return (
    <section className="form-container">
      <form onSubmit={handleSubmit}>
        <fieldset>
          <div className="form-header">
            <legend>{data.elements.title?.value}</legend>
          </div>

          <div className="row">
            <label className="field-label" htmlFor="birthday">
              Your Birthday
            </label>
            <input
              id="birthday"
              data-testid="birthday"
              type="date"
              name="birthday"
              className="half"
              data-ph-sensitive
              required
              value={birthday}
              onChange={(e) => setBirthday(e.target.value)}
              aria-invalid={Boolean(birthdayError)}
              aria-describedby={birthdayError ? 'birthday-error' : undefined}
            />
          </div>
          {birthdayError && (
            <FormError error={birthdayError} id="birthday-error" />
          )}

          <button
            className="button primary submit"
            type="submit"
            disabled={!birthday}
          >
            Submit
          </button>

          {isPending && <div className="spinner"></div>}
        </fieldset>
      </form>
    </section>
  );
};

export default BEQLookupForm;
